import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'eidos-progress-spinner',
  styleUrls: ['eidos-progress-spinner.component.scss'],
  templateUrl: 'eidos-progress-spinner.component.html'
})
export class EidosProgressSpinnerComponent implements OnInit {

  constructor() {
  }

  @Input()
  public value: number = 100;

  @Input()
  diameter: number = 100;

  @Input()
  mode: string = 'indeterminate';

  @Input()
  strokeWidth: number = 10;

  @Input()
  overlay: boolean = true;

  @Input()
  color: string = 'primary';

  get resolvedStrokeWidth(): number {
    if (this.strokeWidth !== 10) {
      return this.strokeWidth;
    }
    return Math.max(2, Math.round(this.diameter * 0.1));
  }

  ngOnInit() {
  }
}
